module.exports = __webpack_public_path__ + "img/act-of-emotion-2-mobile.5a1c0a98.jpg";